export default {"src":"/_next/static/media/start.7c2f041a.svg","height":125,"width":169,"blurWidth":0,"blurHeight":0};